<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheInputText title="Tên" placeholder="Tìm theo tên" :initialValue="sValue_TEN"
                                v-model="sValue_TEN" :isRequire=false @onChange="v => handlePageChange(1)" />
                        </div>

                        <div class="col mb-3">
                            <label>
                                Menu cha
                            </label>
                            <select id="menuCha_sOptions" class="form-control select2bs4" style="width: 100%">
                                <option value="">-- Tất cả menu cha --</option>
                                <option v-for="item in category_MENUCHA" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col mb-3">
                            <div class="form-group">
                                <label>
                                    <span>Hiển thị trên cổng</span>
                                </label>
                                <select id="enabled_sOptions" class="form-control select2bs4" style="width: 100%">
                                    <option :value=null>--- Tất cả ---</option>
                                    <option :value=true>Bật</option>
                                    <option :value=false>Tắt</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" @click="detail(null, 'create')"
                            v-bind:title="$t('labels.create')">
                            <i class="fas fa-plus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col50">
                                        ID
                                    </th>
                                    <th class="col50 cursor" @click="handleSortChange('ten')">
                                        Tên menu
                                        <span v-if="(orderDesc == false && sortBy == 'ten')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'ten')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('menuCode')">
                                        Menu code
                                        <span v-if="(orderDesc == false && sortBy == 'menuCode')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'menuCode')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('capDo')">
                                        Cấp độ
                                        <span v-if="(orderDesc == false && sortBy == 'capDo')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'capDo')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col50">
                                        Đường dẫn
                                    </th>

                                    <th class="col50">
                                        Icon
                                    </th>

                                    <th class="col50 cursor" @click="handleSortChange('menuChaId')">
                                        Tên menu cha
                                        <span v-if="(orderDesc == false && sortBy == 'menuChaId')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'menuChaId')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col10 cursor" @click="handleSortChange('stt')">
                                        STT
                                        <span v-if="(orderDesc == false && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-up" ara-hidden="true"></i>
                                        </span>
                                        <span v-if="(orderDesc == true && sortBy == 'stt')" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col50">Hiển thị trên cổng</th>
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td></td>
                                    <td>{{ item.id }}</td>
                                    <td>{{ item.ten }}</td>
                                    <td>{{ item.menuCode }}</td>
                                    <td>{{ item.capDo }}</td>
                                    <td>{{ item.duongDan }}</td>
                                    <td>{{ item.icon }}</td>
                                    <td>{{ item.tenMenuCha }}</td>
                                    <td>{{ item.stt }}</td>
                                    <td>
                                        <div class="custom-control custom-switch">
                                            <input type="checkbox" class="custom-control-input" :id="'item' + item.id"
                                                v-model="item.enabledDisplay" disabled="true">
                                            <label class="custom-control-label" :for="'item' + item.id"></label>
                                        </div>
                                    </td>
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, 'detail')">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <span v-if="sType_List == 1">
                                            <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                                v-on:click="detail(item, 'update')">
                                                <i class="fas fa-pencil-alt"></i>
                                            </button>&nbsp;
                                        </span>
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, 'delete')">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="insUpdModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-primary">{{ title }}</h4>
                            <button type="button" class="close" aria-label="Close" @click="hideModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Tên menu" placeholder="Nhập tên menu" :initialValue="model.ten"
                                        v-model="model.ten" :error="errors.ten" :isReadOnly="isReadOnly" :isRequire=true
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Menu code" placeholder="Nhập menu code"
                                        :initialValue="model.menuCode" v-model="model.menuCode" :error="errors.menuCode"
                                        :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false"
                                        :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Đường dẫn" placeholder="Nhập đường dẫn"
                                        :initialValue="model.duongDan" v-model="model.duongDan" :error="errors.duongDan"
                                        :isReadOnly="isReadOnly" :isRequire=true :isMultipleLine="false"
                                        :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Icon" placeholder="Nhập icon" :initialValue="model.icon"
                                        v-model="model.icon" :error="errors.icon" :isReadOnly="isReadOnly"
                                        :isRequire=true :isMultipleLine="true" :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Cấp độ" placeholder="Nhập cấp độ" :initialValue="model.capDo"
                                        v-model="model.capDo" :error="errors.capDo" :isReadOnly="isReadOnly"
                                        :isRequire=true :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheSelect title="Menu cha" :options="category_MENUCHA"
                                        :dropdownParent="modalName" :initialValue="model.menuChaId"
                                        :error="errors.menuChaId" :isMultiple="false" :isReadOnly="isReadOnly"
                                        :isAllowClear="true" :isRequire="false"
                                        @onChange="(e) => { model.menuChaId = e }" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="STT" placeholder="Nhập STT" :initialValue="model.stt"
                                        v-model="model.stt" :error="errors.stt" :isReadOnly="isReadOnly" :isRequire=true
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <label>Hiển thị trên cổng</label>
                                </div>
                                <div class="col-md-12">
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="enabled-checkbox"
                                            :disabled="isReadOnly" v-model="model.enabledDisplay">
                                        <label class="custom-control-label" for="enabled-checkbox"></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hideModal()">&nbsp;Đóng</button>

                            <button type="button" class="pull-right" :class="styleButton" v-if="code != 'detail'"
                                @click="onSubmit();">&nbsp;{{ title }}</button>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">Chi tiết</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="modelRec">
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <p class="text-sm">ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.id }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tên
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ten }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Menu code
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.menuCode }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Cấp độ
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.capDo }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Đường dẫn
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.duongDan }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Icon
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.icon }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Menu cha
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenMenuCha }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">STT
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.stt }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Hiển thị trên cổng:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                                            }}&nbsp;</b>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import { menuModel } from '@/models/menu/menu.model'

export default {
    name: "TheMenuDanhSach",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            modelRec: menuModel.newModel(),
            model: menuModel.newFEModel(),
            errors: menuModel.errors(),


            sValue_ID: null,
            sValue_TEN: null,
            sValue_MENUCHA: null,
            sValue_SORT: null,
            sValue_ENABLED: null,

            category_MENUCHA: [],

            sType_List: 1,

            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber'],),
        ...mapActions('menuDanhSach', ['getPagingMenuDanhSach', 'getDetailMenuDanhSach', 'getBasicMenuChaDanhSach', 'createMenuDanhSach', 'updateMenuDanhSach', 'deleteMenuDanhSach']),
        async setup() {
            let header = 'Danh sách menu'
            this.setupHeader({ header })
        },

        async initialize() {
            $('#menuCha_sOptions').on('change', e => {
                let targetValue = e.target.value ? e.target.value : null
                if (!targetValue || targetValue == '') {
                    this.sValue_MENUCHA = null
                    this.getData()
                }
                else {
                    this.sValue_MENUCHA = targetValue
                    this.getData()
                }
            });


            $('#enabled_sOptions').on('change', e => {
                let a = e.target.value
                let returnValue = null
                switch (a) {
                    case "true":
                        returnValue = true
                        break
                    case "false":
                        returnValue = false
                        break
                    default:
                        returnValue = null
                }
                this.sValue_ENABLED = returnValue
                this.handlePageChange(1)
            });
        },
        async showModal() {
            $('#insUpdModal').modal('show')

        },
        async hideModal() {
            $('#insUpdModal').modal('hide')
            // await this.getData()
        },
        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },

        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.sValue_SORT = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == 2) this.sType_List = 1
            else if (this.sType_List == 1) this.sType_List = 2
            await this.handlePageChange(1)
        },

        async getData() {
            this.isBusy = true
            let params = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                menuChaId: this.sValue_MENUCHA,
                ten: this.sValue_TEN,
                sort: this.sValue_SORT,
                enabled: this.sValue_ENABLED,
            }
            await this.getPagingMenuDanhSach({ params: params, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            if (this.code == 'update' || this.code == 'delete' || this.code == 'restore') {
                let params = {
                    id: item.id
                }
                let resp = await this.getDetailMenuDanhSach({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = menuModel.newModel()
                        this.modelRec = resp
                        this.model = menuModel.parseModeltoFEModel(this.modelRec)
                        //this.triggerDetail()
                        //this.isReadOnly = (code == "create") ? false : true
                    }
                });
                this.isReadOnly = (code == "delete" || code == "restore") ? true : false
                this.tempKey = common.randomString(10)
                await this.showModal()

            }
            else if (this.code == 'detail') {
                let params = {
                    id: item.id
                }
                await this.getDetailMenuDanhSach({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = menuModel.newModel()
                        this.modelRec = resp
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
            else {

                this.model = menuModel.newFEModel()
                this.isReadOnly = (code == "create") ? false : true
                //this.isReadOnly = this.isReadOnly = (code == "delete") ? true : false
                // show popup
                this.tempKey = common.randomString(10)
                this.showModal()
            }
        },

        async validate(model) {
            let isvalid = true
            this.errors = menuModel.errors()
            if (!await this.validateRequired(model.ten)) {
                this.errors.ten = "Nhập tên"
                isvalid = false
            }
            // else if (this.code == "update" && this.modelRec.ten != model.ten) {
            //     if (await this.checkExistName(model.ten)) {
            //         this.errors.ten = "Tên này đã tồn tại trên hệ thống"
            //         isvalid = false
            //     }
            // }
            // else if (this.code == "create") {
            //     if (await this.checkExistName(model.ten)) {
            //         this.errors.ten = "Tên này đã tồn tại trên hệ thống"
            //         isvalid = false
            //     }
            // }

            if (!await this.validateRequired(model.stt)) {
                this.errors.stt = "Nhập số thứ tự"
                isvalid = false
            }
            else if (!await this.validateNumber(model.stt)) {
                this.errors.stt = "Số thứ tự phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateRequired(model.duongDan)) {
                this.errors.duongDan = "Nhập đường dẫn"
                isvalid = false
            }
            if (!await this.validateRequired(model.icon)) {
                this.errors.icon = "Nhập icon"
                isvalid = false
            }
            if (!await this.validateRequired(model.menuCode)) {
                this.errors.menuCode = "Nhập menu code"
                isvalid = false
            }

            if (!await this.validateRequired(model.capDo)) {
                this.errors.capDo = "Nhập cấp độ"
                isvalid = false
            }
            else if (!await this.validateNumber(model.capDo)) {
                this.errors.capDo = "Cấp độ phải là kiểu số"
                isvalid = false
            }
            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = menuModel.newModel()
            if (this.code == "update" || this.code == "delete" || this.code == "restore") sendModel.id = FEmodel.id
            sendModel.ten = FEmodel.ten
            sendModel.duongDan = FEmodel.duongDan
            sendModel.icon = FEmodel.icon
            sendModel.menuChaId = FEmodel.menuChaId
            sendModel.menuCode = FEmodel.menuCode
            sendModel.capDo = FEmodel.capDo
            sendModel.stt = FEmodel.stt
            sendModel.enabled = FEmodel.enabledDisplay ? FEmodel.enabledDisplay : false
            return sendModel
        },
        async onSubmit() {
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            let params = null
            switch (code) {
                case "create":
                    if (await this.validate(sendModel)) {
                        res = await this.createMenuDanhSach({ model: sendModel })
                        if (res) {
                            await this.getData()
                            this.hideModal()
                        }
                    }
                    break
                case "update":
                    if (await this.validate(sendModel)) {
                        res = await this.updateMenuDanhSach({ model: sendModel })
                        if (res) {
                            await this.getData()
                            this.hideModal()
                        }
                    }
                    break
                case "delete":
                    // eslint-disable-next-line
                    params = {
                        id: sendModel.id
                    }
                    res = await this.deleteMenuDanhSach({ model: params, type: 2 })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "deleteReal":
                    // eslint-disable-next-line
                    params = {
                        id: sendModel.id
                    }
                    res = await this.deleteQuyenQT({ model: params, type: 2 })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "restore":
                    // eslint-disable-next-line
                    res = await this.restoreQuyenQT({ model: sendModel })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                default:
            }

        },



        async getCategory_MENUCHA() {
            let params = {
            }
            let res = await this.getBasicMenuChaDanhSach({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].menuChaId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }
            return res
        },


    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()

        this.category_MENUCHA = await this.getCategory_MENUCHA()
    }


}
</script>
<style></style>